<template>
  <div>
    <!-- 이벤트 발생 시점 분석 정보 -->
    <div class="mr-b25" v-show="!isEmpty(eventTimeAnalysisInfo)">
      <div class="title-bar">
        <div class="tit content-title">이벤트 발생 시점 분석 정보</div>
        <div class="condition-text">({{ eventDatetime }})</div>
      </div>
      <w-event-time-analysis-info :event-hist-data="eventHistData" :data="eventTimeAnalysisInfo" :exporting-pdf="exportingPdf" />
    </div>
    <!-- 성능 추이 -->
    <div class="mr-b25" v-show="!isEmpty(performanceHistory)">
      <div class="title-bar">
        <div class="tit content-title">성능 추이</div>
        <div class="condition-text">({{ defaultPeriodConditionLabel }})</div>
        <div class="condition-text" style="color:#f56c6c;margin-left:7px;"><i class="fas fa-circle" style="color:rgba(245, 108, 108, 0.5);font-size: 10px;margin-right: 2px"></i>이벤트 발생 시점</div>
      </div>
      <w-performance-history :event-hist-data="eventHistData" :data="performanceHistory" :selected-obj-id="selectedObjId" :exporting-pdf-for-ie="exportingPdfForIe"/>
    </div>
    <!-- 기타 정보 -->
    <w-etc-info :data="etcInfo"/>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateLabel, getDefaultPeriodCondition, getPeriodConditionLabel } from '../../utils/fault-analysis';
import WEventTimeAnalysisInfo from './EventTimeAnalysisInfo';
import WPerformanceHistory from './PerformanceHistory';
import WEtcInfo from './EtcInfo';

/**
 * 장애 분석 화면
 * @author Ju
 */
export default {
  name: 'WFaultAnalysisInfoView',
  components: {
    WEventTimeAnalysisInfo,
    WPerformanceHistory,
    WEtcInfo,
  },
  props: {
    data: {
      type: Object,
    },
    exportingPdf: {
      type: Boolean,
    },
    exportingPdfForIe: {
      type: Boolean,
    },
  },
  data() {
    return {
      obj: {},
      eventHistData: {},
      eventTimeAnalysisInfo: [],
      performanceHistory: [],
      etcInfo: {},
      selectedObjId: 0,
    };
  },
  computed: {
    eventDatetime() {
      return isEmpty(this.eventHistData) ? EMPTY_TEXT : getDateLabel(this.eventHistData.checkDatetime);
    },
    defaultPeriodConditionLabel() {
      if (isEmpty(this.eventHistData)) {
        return EMPTY_TEXT;
      }
      const period = getDefaultPeriodCondition(this.eventHistData.checkDatetime);
      return getPeriodConditionLabel(period.startDatetime, period.endDatetime);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        if (!isNil(to)) {
          this.loadData();
        } else {
          this.reset();
        }
      },
    },
  },
  methods: {
    isEmpty,
    loadData() {
      this.obj = this.data.obj;
      this.eventHistData = this.data.eventHistData;
      this.eventTimeAnalysisInfo = this.data.eventTimeAnalysisInfo;
      this.performanceHistory = this.data.performanceHistory;
      this.etcInfo = {
        obj: this.obj,
        eventHistData: this.eventHistData,
        etcInfo: this.data.etcInfo,
      };
      if (isNil(this.data.selectedObjId)) {
        this.selectedObjId = this.data.selectedObjId;
      }
    },
    reset() {
      this.eventHistData = {};
      this.eventTimeAnalysisInfo = [];
      this.performanceHistory = [];
      this.etcInfo = {};
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/index.vue